import { useCallback, useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import AccountsService from "../../services/accounts";
import { useGetContractRole } from "./getContractRole";
import EXTERNAL_USER_CONTRACT_ROLES from "../../types/enums/ExternalUserContractRole";

export const useFetchExternalPortalAccountData = (
  accountNumber: number,
  setError?: React.Dispatch<React.SetStateAction<string | null>>,
  accessibleRoles?: EXTERNAL_USER_CONTRACT_ROLES[],
  dependencies?: any[],
) => {
  const navigate: NavigateFunction = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any>(null);
  const [roleInfo, setRoleInfo] = useState<any>(null);

  const { getContractRole } = useGetContractRole();

  const fetchData = useCallback(async () => {
    setIsLoading(true);

    if (Number.isNaN(accountNumber)) {
      setIsLoading(false);
      navigate("/not-found");
      return;
    }

    try {
      const res = await AccountsService.fetchAccountContracts(
        accountNumber.toString(),
      );

      setData(res);
      setRoleInfo(getContractRole(res.generalInformation));

      accessibleRoles &&
        !accessibleRoles.includes(res.generalInformation.role) &&
        navigate("/not-found");

      setIsLoading(false);
    } catch (e: any) {
      var data = e.response.data;

      (data.status === 404 || data.status === 400) &&
        data.title?.toLowerCase().includes("not found") &&
        navigate("/not-found");

      (data.status === 400 || data.status === 403) &&
        setError &&
        setError(data.title);

      setIsLoading(false);
    }
  }, [accessibleRoles, accountNumber, getContractRole, navigate, setError]);

  useEffect(() => {
    if (dependencies && dependencies.length > 0) {
      if (dependencies.some((dep) => dep === null || dep === undefined)) {
        return;
      }
    }
    fetchData();
  }, [dependencies, fetchData]);

  return { data, roleInfo, isLoading };
};
